/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateHchbPatientRequest201Response,
  CreateHchbPatientRequestBody,
  CreateMatrixCareHomeHealthPatientRequest,
  CreatePractitioner200Response,
  CreatePractitionerRequest,
  FindAllHchbAdmissionCoordinators200Response,
  FindAllHchbBranches200Response,
  FindAllHchbFacilities200Response,
  FindAllHchbPatientRequests200Response,
  FindAllHchbPayorSources200Response,
  FindAllHchbPayorTypes200Response,
  FindAllHchbPhysicians200Response,
  FindAllMatrixCareHomeHealthAdmissions200Response,
  FindAllMatrixCareHomeHealthAdmissions400Response,
  FindCurrentHomeHealthCertification200Response,
  FindOneHchbPatientDetails200Response,
  FindOneMatrixCareHomeHealthAdmissionDemographics200Response,
  GetMatrixCareHomeHealthAdmission200Response,
  GetMatrixCareHomeHealthLookups200Response,
  LookupZipOptions200Response,
  SearchMatrixCareHomeHealthOrganizations200Response,
  SearchMatrixCareHomeHealthPatients200Response,
  SearchPractitioners200Response,
  StartExecution202Response,
  StartExecutionRequest,
  UploadHchbDocumentsRequest,
} from '../models/index';
import {
    CreateHchbPatientRequest201ResponseFromJSON,
    CreateHchbPatientRequest201ResponseToJSON,
    CreateHchbPatientRequestBodyFromJSON,
    CreateHchbPatientRequestBodyToJSON,
    CreateMatrixCareHomeHealthPatientRequestFromJSON,
    CreateMatrixCareHomeHealthPatientRequestToJSON,
    CreatePractitioner200ResponseFromJSON,
    CreatePractitioner200ResponseToJSON,
    CreatePractitionerRequestFromJSON,
    CreatePractitionerRequestToJSON,
    FindAllHchbAdmissionCoordinators200ResponseFromJSON,
    FindAllHchbAdmissionCoordinators200ResponseToJSON,
    FindAllHchbBranches200ResponseFromJSON,
    FindAllHchbBranches200ResponseToJSON,
    FindAllHchbFacilities200ResponseFromJSON,
    FindAllHchbFacilities200ResponseToJSON,
    FindAllHchbPatientRequests200ResponseFromJSON,
    FindAllHchbPatientRequests200ResponseToJSON,
    FindAllHchbPayorSources200ResponseFromJSON,
    FindAllHchbPayorSources200ResponseToJSON,
    FindAllHchbPayorTypes200ResponseFromJSON,
    FindAllHchbPayorTypes200ResponseToJSON,
    FindAllHchbPhysicians200ResponseFromJSON,
    FindAllHchbPhysicians200ResponseToJSON,
    FindAllMatrixCareHomeHealthAdmissions200ResponseFromJSON,
    FindAllMatrixCareHomeHealthAdmissions200ResponseToJSON,
    FindAllMatrixCareHomeHealthAdmissions400ResponseFromJSON,
    FindAllMatrixCareHomeHealthAdmissions400ResponseToJSON,
    FindCurrentHomeHealthCertification200ResponseFromJSON,
    FindCurrentHomeHealthCertification200ResponseToJSON,
    FindOneHchbPatientDetails200ResponseFromJSON,
    FindOneHchbPatientDetails200ResponseToJSON,
    FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSON,
    FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseToJSON,
    GetMatrixCareHomeHealthAdmission200ResponseFromJSON,
    GetMatrixCareHomeHealthAdmission200ResponseToJSON,
    GetMatrixCareHomeHealthLookups200ResponseFromJSON,
    GetMatrixCareHomeHealthLookups200ResponseToJSON,
    LookupZipOptions200ResponseFromJSON,
    LookupZipOptions200ResponseToJSON,
    SearchMatrixCareHomeHealthOrganizations200ResponseFromJSON,
    SearchMatrixCareHomeHealthOrganizations200ResponseToJSON,
    SearchMatrixCareHomeHealthPatients200ResponseFromJSON,
    SearchMatrixCareHomeHealthPatients200ResponseToJSON,
    SearchPractitioners200ResponseFromJSON,
    SearchPractitioners200ResponseToJSON,
    StartExecution202ResponseFromJSON,
    StartExecution202ResponseToJSON,
    StartExecutionRequestFromJSON,
    StartExecutionRequestToJSON,
    UploadHchbDocumentsRequestFromJSON,
    UploadHchbDocumentsRequestToJSON,
} from '../models/index';

export interface CreateHchbPatientRequestRequest {
    createHchbPatientRequestBody: CreateHchbPatientRequestBody;
}

export interface CreateMatrixCareHomeHealthPatientOperationRequest {
    leadId: string;
    createMatrixCareHomeHealthPatientRequest: CreateMatrixCareHomeHealthPatientRequest;
}

export interface CreatePractitionerOperationRequest {
    createPractitionerRequest: CreatePractitionerRequest;
}

export interface FindAllHchbAdmissionCoordinatorsRequest {
    facilityId: string;
    search?: string;
    page?: number;
    limit?: number;
}

export interface FindAllHchbBranchesRequest {
    facilityId: string;
}

export interface FindAllHchbFacilitiesRequest {
    facilityId: string;
    search?: string;
    searchable?: boolean;
    page?: number;
    limit?: number;
}

export interface FindAllHchbPatientRequestsRequest {
    leadId: string;
}

export interface FindAllHchbPayorSourcesRequest {
    payorTypeId: string;
    search?: string;
    serviceLineType?: string;
    page?: number;
    limit?: number;
}

export interface FindAllHchbPayorTypesRequest {
    facilityId: string;
    search?: string;
    serviceLineType?: string;
    page?: number;
    limit?: number;
}

export interface FindAllHchbPhysiciansRequest {
    facilityId: string;
    search?: string;
    searchable?: boolean;
    page?: number;
    limit?: number;
}

export interface FindAllMatrixCareHomeHealthAdmissionsRequest {
    leadId: string;
    patientId: string;
}

export interface FindAllMatrixCareHomeHealthCopySourcesRequest {
    leadId: string;
    patientId: string;
    patientDemoId: string;
}

export interface FindCurrentHomeHealthCertificationRequest {
    leadId: string;
}

export interface FindOneHchbPatientDetailsRequest {
    leadId: string;
}

export interface FindOneMatrixCareHomeHealthAdmissionDemographicsRequest {
    leadId: string;
    patientId: string;
    admissionId: string;
}

export interface GetMatrixCareHomeHealthAdmissionRequest {
    leadId: string;
}

export interface GetMatrixCareHomeHealthLookupsRequest {
    leadId: string;
    businessUnitId?: string;
}

export interface LinkMatrixCareHomeHealthPatientRequest {
    leadId: string;
    patientId: string;
}

export interface LookupZipOptionsRequest {
    facilityId: string;
    zip: string;
}

export interface SearchMatrixCareHomeHealthOrganizationsRequest {
    leadId: string;
    businessUnitId: string;
    referralSourceId: string;
    search: string;
}

export interface SearchMatrixCareHomeHealthPatientsRequest {
    leadId: string;
    lastName: string;
    dateOfBirth: string;
    firstName?: string;
}

export interface SearchPractitionersRequest {
    search: string;
    facilityId: string;
    limit?: number;
    source?: SearchPractitionersSourceEnum;
}

export interface StartExecutionOperationRequest {
    startExecutionRequest: StartExecutionRequest;
}

export interface UploadHchbDocumentsOperationRequest {
    leadId: string;
    uploadHchbDocumentsRequest: UploadHchbDocumentsRequest;
}

export interface UploadMatrixCareHomeHealthDocumentsRequest {
    leadId: string;
    uploadHchbDocumentsRequest: UploadHchbDocumentsRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Create an HCHB patient creation request
     */
    async createHchbPatientRequestRaw(requestParameters: CreateHchbPatientRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateHchbPatientRequest201Response>> {
        if (requestParameters['createHchbPatientRequestBody'] == null) {
            throw new runtime.RequiredError(
                'createHchbPatientRequestBody',
                'Required parameter "createHchbPatientRequestBody" was null or undefined when calling createHchbPatientRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/homecare-homebase/patient-requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateHchbPatientRequestBodyToJSON(requestParameters['createHchbPatientRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateHchbPatientRequest201ResponseFromJSON(jsonValue));
    }

    /**
     * Create an HCHB patient creation request
     */
    async createHchbPatientRequest(requestParameters: CreateHchbPatientRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateHchbPatientRequest201Response> {
        const response = await this.createHchbPatientRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enqueue a MatrixCare Home Health patient creation. Handled asynchronously by the uploader worker.
     */
    async createMatrixCareHomeHealthPatientRaw(requestParameters: CreateMatrixCareHomeHealthPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createMatrixCareHomeHealthPatient().'
            );
        }

        if (requestParameters['createMatrixCareHomeHealthPatientRequest'] == null) {
            throw new runtime.RequiredError(
                'createMatrixCareHomeHealthPatientRequest',
                'Required parameter "createMatrixCareHomeHealthPatientRequest" was null or undefined when calling createMatrixCareHomeHealthPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/patient`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMatrixCareHomeHealthPatientRequestToJSON(requestParameters['createMatrixCareHomeHealthPatientRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enqueue a MatrixCare Home Health patient creation. Handled asynchronously by the uploader worker.
     */
    async createMatrixCareHomeHealthPatient(requestParameters: CreateMatrixCareHomeHealthPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMatrixCareHomeHealthPatientRaw(requestParameters, initOverrides);
    }

    /**
     * Save a practitioner entered manually or selected from NPPES
     */
    async createPractitionerRaw(requestParameters: CreatePractitionerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePractitioner200Response>> {
        if (requestParameters['createPractitionerRequest'] == null) {
            throw new runtime.RequiredError(
                'createPractitionerRequest',
                'Required parameter "createPractitionerRequest" was null or undefined when calling createPractitioner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/practitioners`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePractitionerRequestToJSON(requestParameters['createPractitionerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePractitioner200ResponseFromJSON(jsonValue));
    }

    /**
     * Save a practitioner entered manually or selected from NPPES
     */
    async createPractitioner(requestParameters: CreatePractitionerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePractitioner200Response> {
        const response = await this.createPractitionerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB admission coordinators
     */
    async findAllHchbAdmissionCoordinatorsRaw(requestParameters: FindAllHchbAdmissionCoordinatorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbAdmissionCoordinators200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbAdmissionCoordinators().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/admission-coordinators`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbAdmissionCoordinators200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB admission coordinators
     */
    async findAllHchbAdmissionCoordinators(requestParameters: FindAllHchbAdmissionCoordinatorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbAdmissionCoordinators200Response> {
        const response = await this.findAllHchbAdmissionCoordinatorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List HCHB branches with teams for a facility
     */
    async findAllHchbBranchesRaw(requestParameters: FindAllHchbBranchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbBranches200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbBranches().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/branches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbBranches200ResponseFromJSON(jsonValue));
    }

    /**
     * List HCHB branches with teams for a facility
     */
    async findAllHchbBranches(requestParameters: FindAllHchbBranchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbBranches200Response> {
        const response = await this.findAllHchbBranchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB facilities
     */
    async findAllHchbFacilitiesRaw(requestParameters: FindAllHchbFacilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbFacilities200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbFacilities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['searchable'] != null) {
            queryParameters['searchable'] = requestParameters['searchable'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/facilities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbFacilities200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB facilities
     */
    async findAllHchbFacilities(requestParameters: FindAllHchbFacilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbFacilities200Response> {
        const response = await this.findAllHchbFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List HCHB patient requests for a lead
     */
    async findAllHchbPatientRequestsRaw(requestParameters: FindAllHchbPatientRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPatientRequests200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllHchbPatientRequests().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['leadId'] != null) {
            queryParameters['lead_id'] = requestParameters['leadId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/patient-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPatientRequests200ResponseFromJSON(jsonValue));
    }

    /**
     * List HCHB patient requests for a lead
     */
    async findAllHchbPatientRequests(requestParameters: FindAllHchbPatientRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPatientRequests200Response> {
        const response = await this.findAllHchbPatientRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB payor sources
     */
    async findAllHchbPayorSourcesRaw(requestParameters: FindAllHchbPayorSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPayorSources200Response>> {
        if (requestParameters['payorTypeId'] == null) {
            throw new runtime.RequiredError(
                'payorTypeId',
                'Required parameter "payorTypeId" was null or undefined when calling findAllHchbPayorSources().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['payorTypeId'] != null) {
            queryParameters['payor_type_id'] = requestParameters['payorTypeId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['serviceLineType'] != null) {
            queryParameters['service_line_type'] = requestParameters['serviceLineType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/payor-sources`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPayorSources200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB payor sources
     */
    async findAllHchbPayorSources(requestParameters: FindAllHchbPayorSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPayorSources200Response> {
        const response = await this.findAllHchbPayorSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB payor types
     */
    async findAllHchbPayorTypesRaw(requestParameters: FindAllHchbPayorTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPayorTypes200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbPayorTypes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['serviceLineType'] != null) {
            queryParameters['service_line_type'] = requestParameters['serviceLineType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/payor-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPayorTypes200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB payor types
     */
    async findAllHchbPayorTypes(requestParameters: FindAllHchbPayorTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPayorTypes200Response> {
        const response = await this.findAllHchbPayorTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB physicians
     */
    async findAllHchbPhysiciansRaw(requestParameters: FindAllHchbPhysiciansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPhysicians200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbPhysicians().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['searchable'] != null) {
            queryParameters['searchable'] = requestParameters['searchable'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/physicians`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPhysicians200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB physicians
     */
    async findAllHchbPhysicians(requestParameters: FindAllHchbPhysiciansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPhysicians200Response> {
        const response = await this.findAllHchbPhysiciansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List a MatrixCare patient\'s admissions, read live from MatrixCare.
     */
    async findAllMatrixCareHomeHealthAdmissionsRaw(requestParameters: FindAllMatrixCareHomeHealthAdmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllMatrixCareHomeHealthAdmissions200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllMatrixCareHomeHealthAdmissions().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling findAllMatrixCareHomeHealthAdmissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/admissions`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))).replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllMatrixCareHomeHealthAdmissions200ResponseFromJSON(jsonValue));
    }

    /**
     * List a MatrixCare patient\'s admissions, read live from MatrixCare.
     */
    async findAllMatrixCareHomeHealthAdmissions(requestParameters: FindAllMatrixCareHomeHealthAdmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllMatrixCareHomeHealthAdmissions200Response> {
        const response = await this.findAllMatrixCareHomeHealthAdmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List admissions MatrixCare accepts as a copy source for a new admission.
     */
    async findAllMatrixCareHomeHealthCopySourcesRaw(requestParameters: FindAllMatrixCareHomeHealthCopySourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllMatrixCareHomeHealthAdmissions200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllMatrixCareHomeHealthCopySources().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling findAllMatrixCareHomeHealthCopySources().'
            );
        }

        if (requestParameters['patientDemoId'] == null) {
            throw new runtime.RequiredError(
                'patientDemoId',
                'Required parameter "patientDemoId" was null or undefined when calling findAllMatrixCareHomeHealthCopySources().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['patientDemoId'] != null) {
            queryParameters['patient_demo_id'] = requestParameters['patientDemoId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/copy-sources`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))).replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllMatrixCareHomeHealthAdmissions200ResponseFromJSON(jsonValue));
    }

    /**
     * List admissions MatrixCare accepts as a copy source for a new admission.
     */
    async findAllMatrixCareHomeHealthCopySources(requestParameters: FindAllMatrixCareHomeHealthCopySourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllMatrixCareHomeHealthAdmissions200Response> {
        const response = await this.findAllMatrixCareHomeHealthCopySourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the current Home Health certification extraction for a lead.
     */
    async findCurrentHomeHealthCertificationRaw(requestParameters: FindCurrentHomeHealthCertificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindCurrentHomeHealthCertification200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findCurrentHomeHealthCertification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/home-health-certification`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindCurrentHomeHealthCertification200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the current Home Health certification extraction for a lead.
     */
    async findCurrentHomeHealthCertification(requestParameters: FindCurrentHomeHealthCertificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindCurrentHomeHealthCertification200Response> {
        const response = await this.findCurrentHomeHealthCertificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find One HCHB patient\'s details
     */
    async findOneHchbPatientDetailsRaw(requestParameters: FindOneHchbPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneHchbPatientDetails200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOneHchbPatientDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/leads/{lead_id}/patient-details`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneHchbPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Find One HCHB patient\'s details
     */
    async findOneHchbPatientDetails(requestParameters: FindOneHchbPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneHchbPatientDetails200Response> {
        const response = await this.findOneHchbPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read an admission\'s demographics live from MatrixCare.
     */
    async findOneMatrixCareHomeHealthAdmissionDemographicsRaw(requestParameters: FindOneMatrixCareHomeHealthAdmissionDemographicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneMatrixCareHomeHealthAdmissionDemographics200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOneMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling findOneMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        if (requestParameters['admissionId'] == null) {
            throw new runtime.RequiredError(
                'admissionId',
                'Required parameter "admissionId" was null or undefined when calling findOneMatrixCareHomeHealthAdmissionDemographics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/admissions/{admission_id}/demographics`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))).replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"admission_id"}}`, encodeURIComponent(String(requestParameters['admissionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSON(jsonValue));
    }

    /**
     * Read an admission\'s demographics live from MatrixCare.
     */
    async findOneMatrixCareHomeHealthAdmissionDemographics(requestParameters: FindOneMatrixCareHomeHealthAdmissionDemographicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneMatrixCareHomeHealthAdmissionDemographics200Response> {
        const response = await this.findOneMatrixCareHomeHealthAdmissionDemographicsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the latest MatrixCare Home Health admission for a lead.
     */
    async getMatrixCareHomeHealthAdmissionRaw(requestParameters: GetMatrixCareHomeHealthAdmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMatrixCareHomeHealthAdmission200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getMatrixCareHomeHealthAdmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/admission`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatrixCareHomeHealthAdmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the latest MatrixCare Home Health admission for a lead.
     */
    async getMatrixCareHomeHealthAdmission(requestParameters: GetMatrixCareHomeHealthAdmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMatrixCareHomeHealthAdmission200Response> {
        const response = await this.getMatrixCareHomeHealthAdmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch all picklists needed to render the MatrixCare Home Health create-patient form.
     */
    async getMatrixCareHomeHealthLookupsRaw(requestParameters: GetMatrixCareHomeHealthLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMatrixCareHomeHealthLookups200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getMatrixCareHomeHealthLookups().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['businessUnitId'] != null) {
            queryParameters['business_unit_id'] = requestParameters['businessUnitId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/lookups`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatrixCareHomeHealthLookups200ResponseFromJSON(jsonValue));
    }

    /**
     * Fetch all picklists needed to render the MatrixCare Home Health create-patient form.
     */
    async getMatrixCareHomeHealthLookups(requestParameters: GetMatrixCareHomeHealthLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMatrixCareHomeHealthLookups200Response> {
        const response = await this.getMatrixCareHomeHealthLookupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Writes only to ExaCare. Re-reads the patient\'s admissions from MatrixCare at link time, so the imported set reflects the vendor rather than a stale client view. Safe to retry: linking the same patient again returns the same link.
     * Link a lead to an existing MatrixCare patient and import their admissions.
     */
    async linkMatrixCareHomeHealthPatientRaw(requestParameters: LinkMatrixCareHomeHealthPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMatrixCareHomeHealthAdmission200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling linkMatrixCareHomeHealthPatient().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling linkMatrixCareHomeHealthPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/patients/{patient_id}/link`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))).replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatrixCareHomeHealthAdmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Writes only to ExaCare. Re-reads the patient\'s admissions from MatrixCare at link time, so the imported set reflects the vendor rather than a stale client view. Safe to retry: linking the same patient again returns the same link.
     * Link a lead to an existing MatrixCare patient and import their admissions.
     */
    async linkMatrixCareHomeHealthPatient(requestParameters: LinkMatrixCareHomeHealthPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMatrixCareHomeHealthAdmission200Response> {
        const response = await this.linkMatrixCareHomeHealthPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Look up city/state/county options for a zip code
     */
    async lookupZipOptionsRaw(requestParameters: LookupZipOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LookupZipOptions200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling lookupZipOptions().'
            );
        }

        if (requestParameters['zip'] == null) {
            throw new runtime.RequiredError(
                'zip',
                'Required parameter "zip" was null or undefined when calling lookupZipOptions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['zip'] != null) {
            queryParameters['zip'] = requestParameters['zip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/zip-lookup`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LookupZipOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Look up city/state/county options for a zip code
     */
    async lookupZipOptions(requestParameters: LookupZipOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LookupZipOptions200Response> {
        const response = await this.lookupZipOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search MatrixCare Home Health referral organizations.
     */
    async searchMatrixCareHomeHealthOrganizationsRaw(requestParameters: SearchMatrixCareHomeHealthOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMatrixCareHomeHealthOrganizations200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling searchMatrixCareHomeHealthOrganizations().'
            );
        }

        if (requestParameters['businessUnitId'] == null) {
            throw new runtime.RequiredError(
                'businessUnitId',
                'Required parameter "businessUnitId" was null or undefined when calling searchMatrixCareHomeHealthOrganizations().'
            );
        }

        if (requestParameters['referralSourceId'] == null) {
            throw new runtime.RequiredError(
                'referralSourceId',
                'Required parameter "referralSourceId" was null or undefined when calling searchMatrixCareHomeHealthOrganizations().'
            );
        }

        if (requestParameters['search'] == null) {
            throw new runtime.RequiredError(
                'search',
                'Required parameter "search" was null or undefined when calling searchMatrixCareHomeHealthOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['businessUnitId'] != null) {
            queryParameters['business_unit_id'] = requestParameters['businessUnitId'];
        }

        if (requestParameters['referralSourceId'] != null) {
            queryParameters['referral_source_id'] = requestParameters['referralSourceId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/organizations`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchMatrixCareHomeHealthOrganizations200ResponseFromJSON(jsonValue));
    }

    /**
     * Search MatrixCare Home Health referral organizations.
     */
    async searchMatrixCareHomeHealthOrganizations(requestParameters: SearchMatrixCareHomeHealthOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMatrixCareHomeHealthOrganizations200Response> {
        const response = await this.searchMatrixCareHomeHealthOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search MatrixCare Home Health for possibly-existing patients matching the lead\'s demographics.
     */
    async searchMatrixCareHomeHealthPatientsRaw(requestParameters: SearchMatrixCareHomeHealthPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchMatrixCareHomeHealthPatients200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling searchMatrixCareHomeHealthPatients().'
            );
        }

        if (requestParameters['lastName'] == null) {
            throw new runtime.RequiredError(
                'lastName',
                'Required parameter "lastName" was null or undefined when calling searchMatrixCareHomeHealthPatients().'
            );
        }

        if (requestParameters['dateOfBirth'] == null) {
            throw new runtime.RequiredError(
                'dateOfBirth',
                'Required parameter "dateOfBirth" was null or undefined when calling searchMatrixCareHomeHealthPatients().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['dateOfBirth'] != null) {
            queryParameters['date_of_birth'] = requestParameters['dateOfBirth'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/patient-search`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchMatrixCareHomeHealthPatients200ResponseFromJSON(jsonValue));
    }

    /**
     * Search MatrixCare Home Health for possibly-existing patients matching the lead\'s demographics.
     */
    async searchMatrixCareHomeHealthPatients(requestParameters: SearchMatrixCareHomeHealthPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchMatrixCareHomeHealthPatients200Response> {
        const response = await this.searchMatrixCareHomeHealthPatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search practitioners across saved records and the NPPES registry
     */
    async searchPractitionersRaw(requestParameters: SearchPractitionersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPractitioners200Response>> {
        if (requestParameters['search'] == null) {
            throw new runtime.RequiredError(
                'search',
                'Required parameter "search" was null or undefined when calling searchPractitioners().'
            );
        }

        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling searchPractitioners().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/practitioners`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPractitioners200ResponseFromJSON(jsonValue));
    }

    /**
     * Search practitioners across saved records and the NPPES registry
     */
    async searchPractitioners(requestParameters: SearchPractitionersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPractitioners200Response> {
        const response = await this.searchPractitionersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start an HCHB automation execution
     */
    async startExecutionRaw(requestParameters: StartExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartExecution202Response>> {
        if (requestParameters['startExecutionRequest'] == null) {
            throw new runtime.RequiredError(
                'startExecutionRequest',
                'Required parameter "startExecutionRequest" was null or undefined when calling startExecution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/homecare-homebase/executions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartExecutionRequestToJSON(requestParameters['startExecutionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartExecution202ResponseFromJSON(jsonValue));
    }

    /**
     * Start an HCHB automation execution
     */
    async startExecution(requestParameters: StartExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartExecution202Response> {
        const response = await this.startExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload documents to HCHB
     */
    async uploadHchbDocumentsRaw(requestParameters: UploadHchbDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneHchbPatientDetails200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling uploadHchbDocuments().'
            );
        }

        if (requestParameters['uploadHchbDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadHchbDocumentsRequest',
                'Required parameter "uploadHchbDocumentsRequest" was null or undefined when calling uploadHchbDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/homecare-homebase/leads/{lead_id}/patient-documents`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadHchbDocumentsRequestToJSON(requestParameters['uploadHchbDocumentsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneHchbPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload documents to HCHB
     */
    async uploadHchbDocuments(requestParameters: UploadHchbDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneHchbPatientDetails200Response> {
        const response = await this.uploadHchbDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enqueue documents to be pushed to MatrixCare Home Health.
     */
    async uploadMatrixCareHomeHealthDocumentsRaw(requestParameters: UploadMatrixCareHomeHealthDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling uploadMatrixCareHomeHealthDocuments().'
            );
        }

        if (requestParameters['uploadHchbDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadHchbDocumentsRequest',
                'Required parameter "uploadHchbDocumentsRequest" was null or undefined when calling uploadMatrixCareHomeHealthDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/patient/details`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadHchbDocumentsRequestToJSON(requestParameters['uploadHchbDocumentsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enqueue documents to be pushed to MatrixCare Home Health.
     */
    async uploadMatrixCareHomeHealthDocuments(requestParameters: UploadMatrixCareHomeHealthDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadMatrixCareHomeHealthDocumentsRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const SearchPractitionersSourceEnum = {
    Local: 'local',
    Nppes: 'nppes'
} as const;
export type SearchPractitionersSourceEnum = typeof SearchPractitionersSourceEnum[keyof typeof SearchPractitionersSourceEnum];
